import { Alert, Box, Section } from '@factorialco/deprecated-design-system'
import { ImportContractsRootPageDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import NotFound from 'modules/core/components/NotFound'
import type { WithMultiSelectStateChildrenProps } from 'modules/core/components/WithMultiSelectState'
import WithMultiSelectState from 'modules/core/components/WithMultiSelectState'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import Importer from 'modules/employees/components/ContractImporter'
import { useContractsImporter } from 'modules/employees/components/ContractImporter/contractsImporterContext'

import ImportTable from './components/ImportTable'
import type { ImportedContract } from './components/ImportTable/Content/types'

const Content = () => {
  const importer = useContractsImporter()

  return (
    <WithMultiSelectState items={importer.contracts} initialSelection={importer.readyContracts}>
      {({
        onDeselectAll,
        onSelectAll,
        onToggleSelectedItem,
        items,
        selected,
      }: WithMultiSelectStateChildrenProps<ImportedContract>) => (
        <>
          <Section
            illustration="multiple-actions-upload"
            title={i18n.t('import_contract.table.title')}
            description={i18n.t('import_contract.table.description')}
          >
            <Importer importer={importer} openModalOnDrop />
          </Section>
          <Box padding="s64" width="full">
            {importer.isOverlimited && (
              <Box paddingBottom="s24">
                <Alert color="warning">
                  {i18n.t('overlimit_employees.contract_importer.warning', {
                    limitEmployeesCurrentPlan: importer.maxContractsAllowedImport,
                    newContracts: importer.newContracts,
                  })}
                </Alert>
              </Box>
            )}
            <ImportTable
              contracts={items}
              selected={selected}
              attributes={importer.attributes}
              customFields={importer.customFields}
              onToggleSelectedItem={onToggleSelectedItem}
              onDeselectAll={onDeselectAll}
              onSelectAll={onSelectAll}
            />
          </Box>
        </>
      )}
    </WithMultiSelectState>
  )
}

const ImportContractsPage = () => {
  const { data } = useQuery(ImportContractsRootPageDocument)
  const canManageImports = data?.employees?._policies.exportEmployees.can ?? false
  if (!canManageImports) {
    return <NotFound />
  }

  return <Content />
}

export default observer(ImportContractsPage)
